<div class="compare-products" *ngIf="productsToCompare$ | async as productForCompares">
  <div class="compare-products__header">
    <div class="compare-products__title">{{ 'compare' | transloco }}</div>
    <button
      class="compare-products__button p-button-rounded p-button"
      (click)="removeAllProductsFromComparison()"
      [cpakTrackClick]="ButtonNamesGA.Cancel"
    >
      {{ 'cancel' | transloco }}
    </button>
    <button
      class="compare-products__button compare-products__button_secondary p-button-rounded p-button"
      [disabled]="productForCompares.length < 2"
      (click)="navigateToComparePage()"
      [cpakTrackClick]="ButtonNamesGA.Compare"
    >
      {{ 'compare' | transloco }}
    </button>
  </div>
  <div class="compare-products__items">
    <div
      class="compare-products__item product-item"
      *ngFor="let product of productForCompares"
      (click)="openInCatalog(product.id)"
      [cpakTrackClick]="ButtonNamesGA.OpenInCatalog"
    >
      <div class="product-item__image-wrapper">
        <img class="product-item__image" [src]="product.iconSrc" alt="" cpakErrorImage />
      </div>
      <div class="product-item__basic-info">
        <div class="product-item__name">
          {{ product.name }}
        </div>
        <div class="product-item__additional-info">
          <p-rating
            [readonly]="true"
            [ngModel]="product.rating"
            [stars]="maxRating"
            [cancel]="false"
            class="alc-p-rating"
          >
          </p-rating>
          <div class="product-item__product-number">{{ product.productNumber }}</div>
          <div class="product-item__vendor">{{ product.vendor }}</div>
        </div>
      </div>
      <button
        pButton
        type="button"
        icon="alc-icon-close"
        class="p-button-raised p-button-rounded cross-button product-item__close"
        (click)="removeProductFromComparison($event, product.id)"
        [cpakTrackClick]="ButtonNamesGA.RemoveFromComparison"
      ></button>
    </div>
    <div
      class="compare-products__item"
      *ngFor="let item of [].constructor(maximumNumberOfProductsToCompare - productForCompares.length)"
    ></div>
  </div>
</div>
